import { isFileNameEndsWith } from 'utils/baseName'
/*
 * The file format for .nav has no defined protocol.
 */
/**
 * Checks whether the file name of a file looks like a nav file name.
 * This is done by looking at the extension and checking whether it is ".nav".
 */
// function isNavFileName(fileName: string): boolean
export function isNavFileName (fileName) {
  return isFileNameEndsWith(fileName, '.nav')
}

export function isNavFileType (fileType) {
  return fileType === 'nav'
}

export function isNavApplanixFileType (fileType) {
  return fileType === 'nav_applanix'
}

/**
 * "Parses" a file and checks if it really is a nav file by looking at the filename.
 * **This function does not really parse any information from the ".nav" file**. It is just named like this
 * in order to stay consistent with the naming for other file formats.
 * @param file The file which should be checked.
 * @return An object containing information about whether the file is a valid nav file, a log about the
 *   parsing and the information read from the header.
 */
// function parseNavFile(file: File): Promise<GenericParserInfo>
export async function parseNavFile (file) {
  return new Promise(resolve => {
    const log = []
    if (!isNavFileName(file.name)) {
      log.push({
        level: 'error',
        message: `Unsupported file extension in filename "${file.name}"`,
      })
      resolve({ okay: false, log, fileType: 'nav' })
    }
    if (file.size === 0) {
      log.push({ level: 'error', message: 'Invalid file size. File is empty.' })
      resolve({ okay: false, log, fileType: 'nav' })
      return
    }
    resolve({ okay: true, log, fileType: 'nav' })
  })
}
